module.exports = { getStudyFields, getStudyInfo, getTsInfo };
// module.exports = getTsInfo;

function getStudyFields(strExpr, strFields) {
  // console.log(strStudyName);

  if (strExpr) {
    strFields =
      strFields || "LeadSponsorName,NCTId,OrgStudyId,BriefTitle,Condition";
    // let strAPI =
    //     "https://clinicaltrials.gov/api/query/full_studies?expr=" +
    //     strStudyName +
    //     "&min_rnk=1&max_rnk=&fmt=json";
    // console.log(strAPI);
    let strAPI =
      "https://clinicaltrials.gov/api/query/study_fields?expr=" +
      encodeURIComponent(strExpr) +
      "&fields=" +
      encodeURIComponent(strFields) +
      "&min_rnk=1&max_rnk=&fmt=json";
    return fetch(strAPI)
      .then((res) => res.json())
      .then((res) => {
        if (typeof res !== "undefined") {
          return res["StudyFieldsResponse"];
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
}
function getStudyInfo(strStudyName) {
  // console.log(strStudyName);
  if (strStudyName) {
    // let strAPI =
    //   "https://clinicaltrials.gov/api/query/full_studies?expr=" +
    //   strStudyName +
    //   "&min_rnk=1&max_rnk=&fmt=json";
    // console.log(strAPI);
    let strAPI =
      "https://clinicaltrials.gov/api/v2/studies?query.id=" + strStudyName;
    return fetch(strAPI)
      .then((res) => res.json())
      .then((res) => {
        if (typeof res == "undefined") return {};
        // console.log(res);
        return res["studies"][0].protocolSection;
      })
      .catch((err) => {
        console.log(err);
      });
  }
}

function getTsInfo(strStudyid) {
  let objStudy = getStudyInfo(strStudyid.toUpperCase());
  return objStudy
    .then((res) => res)
    .then((res) => {
      let objTs = {};
      let objIdentificationModule = res.identificationModule || [];
      let objStatusModule = res.statusModule;
      let objDesignModule = res.designModule;
      let objDescriptionModule = res.descriptionModule;
      let objArmsInterventionsModule = res.armsInterventionsModule;
      let objOutcomesModule = res.outcomesModule;
      let objEligibilityModule = res.eligibilityModule;
      let objContactsLocationsModule = res.contactsLocationsModule;
      let objSponsorCollaboratorsModule = res.sponsorCollaboratorsModule;
      let objConditionsModule = res.conditionsModule;
      let objConditionBrowseModule = res.conditionBrowseModule;

      let strSummary = objDescriptionModule.briefSummary || "";
      let strDetaildeDescription =
        objDescriptionModule.detailedDescription || "";
      let strPrimaryObjective = "";
      let strSecondaryObjective = "";
      let strPrimaryFlag = "Primary Objective:";
      let strSecondaryFlag = "Secondary Objective:";
      let intKeyPreIndex = strSummary.indexOf(strPrimaryFlag);
      let intKeySecIndex = strSummary.indexOf(strSecondaryFlag);
      if (intKeyPreIndex == -1) {
        strPrimaryFlag = "Primary Objectives:";
        intKeyPreIndex = strSummary.indexOf(strPrimaryFlag);
      }
      if (intKeySecIndex == -1) {
        strSecondaryFlag = "Secondary Objectives:";
        intKeySecIndex = strSummary.indexOf(strSecondaryFlag);
      }

      let strEnrollmentType = objDesignModule.enrollmentInfo.type || "";

      let strPlanEnrollmentCount;
      let strActualEnrollmentCount;
      let arrTtype = [];
      let arrTtypeGroup = [
        "BIO-AVAILABILITY",
        "BIO-EQUIVALENCE",
        "DIAGNOSIS",
        "DOSE RESPONSE",
        "EFFICACY",
        "FOOD EFFECT",
        "IMMUNOGENICITY",
        "PHARMACODYNAMIC",
        "PHARMACOECONOMIC",
        "PHARMACOGENETIC",
        "PHARMACOGENOMIC",
        "PHARMACOKINETIC",
        "PREVENTION",
        "SAFETY",
        "TOLERABILITY",
        "TREATMENT",
      ];
      if (intKeySecIndex > -1) {
        strPrimaryObjective = strSummary
          .slice(intKeyPreIndex + strPrimaryFlag.length, intKeySecIndex)
          .replace(/\r\n/g, "");
        strSecondaryObjective = strSummary
          .substr(intKeySecIndex + strSecondaryFlag.length)
          .replace(/\r\n/g, "");
      } else {
        strPrimaryObjective = strSummary
          .slice(intKeyPreIndex + strPrimaryFlag.length)
          .replace(/\r\n/g, "");
      }
      if (strEnrollmentType.toUpperCase() == "ACTUAL") {
        strPlanEnrollmentCount = objDesignModule.enrollmentInfo.count;
        strActualEnrollmentCount =
          objDesignModule.enrollmentInfo.EnrollmentCount;
      } else if (strEnrollmentType.toUpperCase() == "ANTICIPATED") {
        strPlanEnrollmentCount = objDesignModule.enrollmentInfo.count;
      }
      let arrSponsor = [];
      arrSponsor.push(objSponsorCollaboratorsModule.leadSponsor.name);
      if (objSponsorCollaboratorsModule.collaborators) {
        let arrCollaborator = objSponsorCollaboratorsModule.collaborators;
        for (let objItem of arrCollaborator) {
          arrSponsor.push(objItem.CollaboratorName);
        }
      }

      objTs["TITLE"] = objIdentificationModule.officialTitle || "";
      objTs["STYPE"] = objDesignModule.studyType || "";
      objTs["TPHASE"] = objDesignModule.phases || [];

      objTs["PLANSUB"] = strPlanEnrollmentCount;
      objTs["ACTSUB"] = strActualEnrollmentCount;
      objTs["INTMODEL"] =
        objDesignModule.designInfo.DesignInterventionModel || "";
      objTs["RANDOM"] = objDesignModule.designInfo.allocation || "";
      objTs["TBLIND"] = objDesignModule.designInfo.maskingInfo.masking || "";
      objTs["TINDTP"] = objDesignModule.designInfo.primaryPurpose || "";
      objTs["REGID"] = objIdentificationModule.nctId || "";
      objTs["SSTDTC"] = objStatusModule.startDateStruct.date || "";
      objTs["SENDTC"] = objStatusModule.completionDateStruct.date || "";
      objTs["OBJPRIM"] = strPrimaryObjective;
      objTs["OBJSEC"] = strSecondaryObjective;
      objTs["LENGTH"] = strDetaildeDescription;
      objTs["SPONSOR"] = arrSponsor;
      objTs["NARMS"] = objArmsInterventionsModule.armGroups.length;
      objTs["TCNTRL"] = objArmsInterventionsModule.armGroups.map(
        (item) => item.label + ":" + item.type
      );
      objTs["TRT"] =
        objArmsInterventionsModule.armGroups
          .filter((item) => item.type == "Experimental")
          .map((item) => item.label) || [];
      objTs["COMPTRT"] =
        objArmsInterventionsModule.armGroups
          .filter((item) => {
            return (
              item.type != "Experimental" &&
              item.label.toUpperCase() != "PLACEBO"
            );
          })
          .map((item) => item.label) || [];

      objTs["INTTYPE"] =
        Array.from(
          new Set(
            objArmsInterventionsModule.interventions.map((item) => item.type)
          )
        ) || [];
      objTs["ROUTE"] = objArmsInterventionsModule.interventions.map((item) => {
        let strRoute = "";
        if (item["description"].split("Route of administration:").length > 1) {
          strRoute = item["description"]
            .split("Route of administration:")[1]
            .trim();
        }
        return strRoute;
      });
      objTs["OUTMSPRI"] =
        objOutcomesModule.primaryOutcomes.map(
          (item) =>
            // item.PrimaryOutcomeTimeFrame +
            // ":" +
            item.measure
        ) || [];
      objTs["OUTMSSEC"] =
        objOutcomesModule.secondaryOutcomes.map(
          (item) =>
            // item.SecondaryOutcomeTimeFrame +
            // ":" +
            item.measure
        ) || [];
      objTs["AGEMIN"] = objEligibilityModule.minimumAge || "";
      objTs["AGEMAX"] = objEligibilityModule.maximumAge || "";
      objTs["SEXPOP"] = objEligibilityModule.sex || "";
      objTs["HLTSUBJI"] = objEligibilityModule.healthyVolunteers;
      objTs["FCNTRY"] = objContactsLocationsModule.locations
        ? Array.from(
            new Set(
              objContactsLocationsModule.locations.map(
                (item) => item.LocationCountry
              )
            )
          )
        : "";
      let strTitleUp = objTs["TITLE"].toUpperCase();
      arrTtype = arrTtypeGroup.filter((item) => {
        let boolExist = false;
        if (strTitleUp.indexOf(item) > -1) {
          boolExist = true;
        }
        return boolExist;
      });
      objTs["TTYPE"] = arrTtype;
      objTs["TDIGRP"] = objConditionsModule.conditions || [];
      let arrIndicatinon = [];

      for (let item of objConditionBrowseModule.browseLeaves) {
        if (item["asFound"]) {
          arrIndicatinon.push(item["asFound"]);
        }
      }
      objTs["INDIC"] = Array.from(new Set(arrIndicatinon));
      return objTs;
    })
    .catch(function (error) {
      console.log(error);
    });
}

// function getTsInfo()
// {
//     let objStudy= getStudyInfo("EFC14112");
//     return objStudy.then(function (value) {
//             let objTs={};
//             let objIdentificationModule=value.IdentificationModule;
//             let objStatusModule=value.StatusModule;
//             let objDesignModule=value.DesignModule;
//             let objDescriptionModule=value.DescriptionModule;
//             let objArmsInterventionsModule=value.ArmsInterventionsModule;
//             let objOutcomesModule=value.OutcomesModule;
//             let objEligibilityModule=value.EligibilityModule;
//             let objContactsLocationsModule=value.ContactsLocationsModule;
//             objTs["TITLE"]=objDescriptionModule.BriefSummary||"";
//             objTs["STYPE"]=objDesignModule.StudyType.toUpperCase()||"";
//             objTs["TPHASE"]=objDesignModule.PhaseList.Phase||[];
//             objTs["PLANSUB"]=objDesignModule.enrollmentInfo.EnrollmentCount||[];
//             objTs["INTMODEL"]=objDesignModule.designInfo.DesignInterventionModel.toUpperCase()||"";
//             objTs["RANDOM"]=objDesignModule.designInfo.DesignAllocation.toUpperCase()||"";
//             objTs["TBLIND"]=objDesignModule.designInfo.DesignMaskingInfo.DesignMasking||"";
//             objTs["REGID"]=objIdentificationModule.NCTId||"";
//             objTs["SSTDTC"]=objStatusModule.startDateStruct.StartDate||"";
//             objTs["SENDTC"]=objStatusModule.completionDateStruct.CompletionDate||"";
//             // objTs["OBJPRIM"]=objDesignModule.designInfo.DesignMaskingInfo.DesignMasking;
//             // objTs["OBJSEC"]=objDesignModule.designInfo.DesignMaskingInfo.DesignMasking;
//             objTs["SPONSOR"]="SANOFI-AVENTIS U.S. LLC";
//             objTs["NARMS"]=objArmsInterventionsModule.armGroups.length;
//             objTs["COMPTRT"]=objArmsInterventionsModule.interventions.map((item)=>item.InterventionName)||[];
//             objTs["OUTMSPRI"]=objOutcomesModule.primaryOutcomes.map((item)=>item.PrimaryOutcomeTimeFrame+":"+item.PrimaryOutcomeMeasure)||[];
//             objTs["OUTMSSEC"]=objOutcomesModule.secondaryOutcomes.map((item)=>item.SecondaryOutcomeTimeFrame+":"+item.SecondaryOutcomeMeasure)||[];
//             objTs["AGEMIN"]=objEligibilityModule.MinimumAge||"";
//             objTs["AGEMAX"]=objEligibilityModule.MaxmumAge||"";
//             objTs["SEXPOP"]=objEligibilityModule.Gender||"";
//             objTs["HLTSUBJI"]=objEligibilityModule.HealthyVolunteers;
//             objTs["FCNTRY"]=Array.from(new Set(objContactsLocationsModule.locations .map((item)=>item.LocationCountry)));
//             return objTs;
//         }).catch(function (error) {
//             console.log(error);
//         })

// }
